import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import GeneralLoader from "../../GeneralLoader";
import ErrorText from "../../utils/error-success/ErrorText";
import VideoItem from "./VideoItem";

// State
import { getTrainingVideos } from "../../../store/actions/trainingVideos";

class VideosList extends Component {
	componentDidMount() {
		this.props.getTrainingVideos(this.props.videoType);
	}

	render() {
		const { translations, videoType, isLoading, errors, videos } = this.props;

		return (
			<div className="pt1 pb2">
				{!isLoading || !!isLoading[videoType] ? (
					<GeneralLoader />
				) : (
					<React.Fragment>
						{!!errors && !!errors[videoType] ? (
							<ErrorText errors={errors[videoType]} />
						) : (
							<div className="training-menu">
								{videos[videoType].data.map((video, i) => (
									<VideoItem
										key={i}
										video={video}
										footer={
											translations.sections.training_video_preview_item
												.view_label
										}
									/>
								))}
							</div>
						)}
					</React.Fragment>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations,
		isLoading: state.trainingVideos.isLoading,
		videos: state.trainingVideos.videos,
		errors: state.trainingVideos.errors
	};
};

export default connect(
	mapStateToProps,
	{ getTrainingVideos }
)(VideosList);



// WEBPACK FOOTER //
// ./src/components/training/videos/VideosList.js